import { typography, Typography } from "components/design/typography";
import React from "react";
import styled from "styled-components";

export type TextElement =
  | "div"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "a"
  | "span"
  | "p"
  | "address"
  | "pre"
  | "strong"
  | "b";

export interface TextProps {
  /** 텍스트 요소 */
  element?: TextElement;
  /** 텍스트 안에 들어갈 content */
  children: React.ReactNode | string;
  /** <a> 태그가 가리키는 URL */
  href?: string;
  /** 글꼴 */
  textType?: Typography;
  /** 글 색상 */
  color?: string;
  /** 보여지는 최대 line 수 */
  numberOfLines?: number;
  /** 커스텀 class */
  className?: string;
  /** Inline CSS */
  style?: React.CSSProperties;
  /** 클릭 이벤트 핸들러 */
  onClick?: (e: React.MouseEvent) => void;
}

interface TextWrapperProps {
  element?: TextElement;
  textType?: Typography;
  color?: string;
  numberOfLines?: number;
  style?: React.CSSProperties;
}

const TextWrapper = styled.span<TextWrapperProps>`
  display: ${({ numberOfLines }) => (numberOfLines ? "-webkit-box" : "inline")};
  ${({ textType }) => textType && typography.get(textType)};
  color: ${({ color }) => color};
  word-break: break-all;
  white-space: ${({ element }) => {
    if (element === "pre") return "pre-line";
    else return "normal";
  }};

  ${({ numberOfLines }) => {
    if (numberOfLines) {
      return `
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${numberOfLines};`;
    }
  }};
  ${({ style }) => style}
`;

const Text: React.FC<TextProps> = ({
  element = "span",
  children,
  href,
  textType,
  color = "inherit",
  className,
  numberOfLines,
  style,
  onClick = () => {},
}) => {
  return (
    <TextWrapper
      element={element}
      as={element}
      href={href}
      textType={textType}
      color={color}
      className={className}
      numberOfLines={numberOfLines}
      style={style}
      onClick={onClick}
    >
      {children}
    </TextWrapper>
  );
};

export default Text;
